export enum DashboardQueries {
    none = 0,
    openDispatches = 1,
    openQuotes = 2,
    quoteSummary = 3,
    quotesPending = 4,
    openContracts = 5,
    invoiceApprovals = 6,
    dispatchEquipmentHistory = 7,
    dispatchStatusGauge = 8,
    quotesPendingApproval = 9,
    openVendorReturns = 10,
    purchaseOrderSummary = 11,
    zeroDollarOrders = 12,
    invoiceSalesSummary = 13,
    monthlyInvoiceSalesDetail = 14,
    kpi = 15,
    techHoursSummary = 16,
    techStatSummary = 17,
    accountReceivablesSummary = 18,
    showCustomerStatistics = 19,
    dispatchReviewLite = 20,
    dispatchreftracking = 21,
    orderReviewLite = 22,
    activeInvoiceDispute = 23,
    creditMemoApproval = 24,
    monthEndDrawRecost = 25,
    dispatchreftracking_v2 = 26,
    zuggitCpDispatchNeedsParts = 27,
    pendingChangeOrders = 28
}
